<template>
  <v-dialog v-model="showVideo" persistent max-width="800">
    <v-card>
      <div class="text-xs-right">
        <v-btn
          flat
          fab
          dark
          small
          color="grey"
          style="line-height: 10px"
          @click="$emit('input', false)"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-text>
        <v-layout row wrap>
          <v-flex class="mb-3" xs12>
            <h3>{{ $t('issue_id') }}</h3>
            <div>{{ data.id.padStart(6, '0') }}</div>
          </v-flex>
          <v-flex class="mb-3" xs6>
            <h3>{{ $t('Date') }}</h3>
            <div>{{ data.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</div>
          </v-flex>
          <v-flex class="mb-3" xs6>
            <h3>{{ $t('emp_id') }}</h3>
            <div>{{ data.employee_id }}</div>
          </v-flex>
          <v-flex class="mb-3" xs6>
            <h3>{{ $t('reporter_name') }}</h3>
            <div>{{ fullName }}</div>
          </v-flex>
          <v-flex class="mb-3" xs6>
            <h3>{{ $t('reporter_position') }}</h3>
            <div>{{ data.position }}</div>
          </v-flex>
          <v-flex class="mb-3" xs6>
            <h3>{{ $t('status') }}</h3>
            <div>
              <StatusSelect
                :value="data.complaint_status"
                @change="
                  (value, toggleLoading) => {
                    $emit('statusChange', data, value, toggleLoading)
                  }
                "
              />
            </div>
          </v-flex>
          <v-flex class="mb-3" xs6>
            <h3>{{ $t('priority') }}</h3>
            <div>{{ data.priority }}</div>
          </v-flex>
          <v-flex class="mb-3" xs6>
            <h3>{{ $t('subject') }}</h3>
            <div>{{ data.topic }}</div>
          </v-flex>
          <v-flex class="mb-3" xs12>
            <h3>{{ $t('complaint_type') }}</h3>
            <div>{{ data.complaint_type }}</div>
          </v-flex>
          <v-flex class="mb-3" xs6>
            <h3>{{ $t('complaint_username') }}</h3>
            <div>{{ data.complaint_username }}</div>
          </v-flex>
          <v-flex class="mb-3" xs6>
            <h3>{{ $t('complaint_department') }}</h3>
            <div>{{ data.complaint_department }}</div>
          </v-flex>
          <v-flex class="mb-3" xs12>
            <h3>{{ $t('detail') }}</h3>
            <div>{{ data.detail }}</div>
          </v-flex>
          <v-flex v-if="data.file" class="mb-3" xs12>
            <h3>{{ $t('File') }}</h3>
            <div>
              <v-btn outline color="primary" :href="data.file" target="_blank">
                <v-icon class="mr-2">visibility</v-icon>
                {{ $t('view') }}
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center align-content-center>
          <v-btn outline color="grey" @click="$emit('input', false)">{{ $t('close') }}</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import StatusSelect from './StatusSelect.vue'

export default {
  components: { StatusSelect },
  props: ['value', 'data'],
  data: function () {
    return {
      showVideo: this.value
    }
  },
  computed: {
    fullName() {
      return [this.data.first_name || '', this.data.last_name || ''].join(' ').trim()
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/reporting/issueReport/ModalReport.vue